/*
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { System } from '@sick-davinci/device-communication';
/**
 * Helper class for ScanChannel handling
 */
export class CrownShapeCapUtil {
    /**
     * the phi channel contains either for each beam one angle
     * or one angel for each beam or
     * or nothing
     */
    static getPhiFloat32Array(phiChannel, numofElements) {
        let retVal;
        if (phiChannel.numOfElems > 1) {
            const phiBuffer = CrownShapeCapUtil.getArrayInCorrectByteOrder32(phiChannel.data, phiChannel.endian);
            retVal = new Float32Array(phiBuffer.buffer, phiBuffer.byteOffset, phiBuffer.byteLength / 4);
        }
        else if (phiChannel.numOfElems === 1) {
            const phiBuffer = CrownShapeCapUtil.getArrayInCorrectByteOrder32(phiChannel.data, phiChannel.endian);
            const phi = new Float32Array(phiBuffer.buffer, phiBuffer.byteOffset, phiBuffer.byteLength / 4)[0];
            retVal = new Float32Array(numofElements);
            retVal.fill(phi);
        }
        else {
            retVal = new Float32Array(numofElements);
            retVal.fill(0);
        }
        return retVal;
    }
    static getArrayInCorrectByteOrder32(data, endianess) {
        const orgArrayUint8 = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        if ((endianess === 'little') !== System.isLE()) {
            const swappedArray = new ArrayBuffer(data.byteLength);
            const swappedArrayUint8 = new Uint8Array(swappedArray, 0, swappedArray.byteLength);
            const len = orgArrayUint8.length;
            for (let i = 0; i < len; i += 4) {
                swappedArrayUint8[i] = orgArrayUint8[i + 3];
                swappedArrayUint8[i + 3] = orgArrayUint8[i];
                swappedArrayUint8[i + 1] = orgArrayUint8[i + 2];
                swappedArrayUint8[i + 2] = orgArrayUint8[i + 1];
            }
            return new DataView(swappedArrayUint8.buffer, swappedArrayUint8.byteOffset, swappedArrayUint8.byteLength);
        }
        // if the offset is not a multiple of 4 Typed Array can not be instanciated
        // therefore the bytes has to be extracted out of the buffer and copied into a new one
        // https://stackoverflow.com/questions/7372124/why-is-creating-a-float32array-with-an-offset-that-isnt-a-multiple-of-the-eleme
        //
        // while this line should be never executed when using crownJSON it can occur with crownMSGPack but it
        // depends a lot on the underlying msgpack implementation. If the msg pack implementation is using just one ArrayBuffer and
        // just returns a DataView with byteOffset and length this can happen quiet often whereas the implementation is copying the data into
        // new ArrayBuffers this code should also never occur
        if (data.byteOffset % 4 !== 0) {
            return new DataView(data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength));
        }
        return data;
    }
}
//# sourceMappingURL=CrownShapeCapUtil.js.map